import React from 'react';
import { browserHistory } from 'react-router';
import GlobalHeader from '../../Fragments/GlobalHeader';

let Quote = require('../../Managers/Quote');
let ReactGA = require('react-ga');

const PaymentFailed = React.createClass ({
    componentWillMount() {
        ReactGA.initialize('UA-1926380-5');
    },

    componentDidMount() {
        if (!Quote.hasQuote()) {
            browserHistory.push('/start');
        }
        window.scrollTo(0, 0);

        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Payment Failed',
            label: 'Quote Form'
        });
    },

    render() {
        return (
            <div>
                <GlobalHeader />
                <div className="stepless" />
                <question-row class="no-border unpadded">
                    <h2>Payment issue</h2>
                </question-row>
                <question-row>
                    <div className="question-main">
                        <div className="field-content">
                            <p>
                                We&rsquo;re sorry, there seems to be a problem with the card details that you&rsquo;ve used to process your payment.
                            </p>
                            <p><b>Your quote reference number is {Quote.getQuote().policyNumber}</b></p>
                        </div>
                        <div className="field-content">
                            <p>
                                Please can you call our landlords insurance team on <span itemProp="telephone"><a href="tel:08000384574">0800 038 4574</a></span> quoting reference number {Quote.getQuote().policyNumber} to complete your cover.
                            </p>
                            <p>
                                Alternatively, you can email <a href="mailto:onlineteam@homelet.co.uk">onlineteam@homelet.co.uk</a> and we&rsquo;ll be happy to assist you.
                            </p>
                        </div>
                    </div>
                </question-row>
            </div>
        );
    }
});

export default PaymentFailed;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/Payment/PaymentFailed.js
 **/